import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '../../api';

/** Every write in the tendering views refreshes the package, the list and the cost plan it feeds. */
export function useTenderMutation<V, R = unknown>(projectId: string, packageId: string, fn: (vars: V) => Promise<R>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tender', projectId, packageId] }),
        queryClient.invalidateQueries({ queryKey: ['tenders', projectId] }),
        queryClient.invalidateQueries({ queryKey: ['costs', projectId] }),
      ]);
    },
  });
}

export function errorText(error: unknown, fallback = 'Speichern fehlgeschlagen.'): string {
  return error instanceof ApiError ? error.message : fallback;
}
